import type { LetterFormat } from './types';

export { generateLetter, generateLetterWithAi } from './generateLetter';
export { parseJobDescription } from './parseJobDescription';
export { matchProfileToJob } from './matchProfile';
export { extractTextFromFile } from './extractJobText';
export { copyLetterToClipboard, downloadLetterAsText, downloadLetterAsDoc, slugify } from './exportLetter';
export { hasEnvOpenAiKey, hasOpenAiKey, resolveOpenAiKey } from './openAiKey';
export type {
  JobDetails,
  LetterFormat,
  LetterTone,
  GeneratedLetter,
  GenerateOptions,
} from './types';

export const LETTER_FORMATS: { id: LetterFormat; label: string; description: string }[] = [
  { id: 'cover_letter', label: 'Cover Letter (Email / PDF)', description: 'Formal letter with greeting and sign-off' },
  { id: 'application_form', label: 'Application Form', description: 'Plain text for ATS or careers portal text box' },
  { id: 'outreach_email', label: 'Outreach Email', description: 'Short email to hiring manager' },
  { id: 'linkedin_message', label: 'LinkedIn Message', description: 'Connection request or InMail' },
  { id: 'follow_up', label: 'Follow-up Email', description: 'After applying' },
  { id: 'recruiter_intro', label: 'Recruiter Intro', description: 'Introduction to a recruiter' },
];
